import { render, staticRenderFns } from "./PanelTemplate.vue?vue&type=template&id=b2e082d8&scoped=true&"
import script from "./PanelTemplate.vue?vue&type=script&lang=ts&"
export * from "./PanelTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./PanelTemplate.vue?vue&type=style&index=0&id=b2e082d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e082d8",
  null
  
)

export default component.exports